import React, { Component } from "react";
import config from "../config.json";
import "../index.css";

class Team extends Component {
  render() {
    const { name, logo } = this.props;
    const imageUrl = config.imagesUrl + (logo || "no-image-found-md.png");

    return (
      <div className="center col-sm-12">
        <img src={imageUrl} alt={name} title={name} />
        <br />
        <span className="m-2 team">{name}</span>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/components/team.jsx